import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

import './style.css';



// Constants
// Possible States of the Component
const STATE_NORMAL = 125;
const STATE_NEED_ATTENTION = 126;
const STATE_INCOMPLETED = 127;

// bootstrap grid
const XS = 767;



export default class ButtonReportLink extends Component {
    

    constructor(props) {
        super(props);

        this.state = {
            hovering: false
        };
        
        this.options = Object.assign({}, options, this.props.options);
    }


    // Lifecycle Methods

    render() {
        let highlightColor = this.options.highlightNormalColor;
        if(Boolean(this.props.displayState) && this.props.displayState === STATE_NEED_ATTENTION)
            highlightColor = this.options.highlightAttentionColor;

        if(Boolean(this.props.displayState) && this.props.displayState === STATE_INCOMPLETED)
            highlightColor = this.options.highlightIncompletedColor;

        const contentContainerStyle = {
            marginLeft: this.options.highlightBorderWidth
        };

        if(this.state.hovering) {
            contentContainerStyle.borderColor = highlightColor;
        }

        const firstViewStyle = {};

        if(this.state.hovering) {
            contentContainerStyle.backgroundColor = highlightColor;

            firstViewStyle.marginTop = -(this.options.height - 2);
        }

        return (
        <div className="hsg-brl-root"
            style={{height: this.options.height}}
            onMouseEnter={(e) => {this.setState({hovering: true}); e.preventDefault();}}
            onMouseLeave={(e) => {this.setState({hovering: false}); e.preventDefault();}}
            onClick={this.props.onClick}>

            <div className="hsg-brl-highlight-border"
                style={{
                    width: this.options.highlightBorderWidth,
                    backgroundColor: highlightColor
                }} />


            <div className="hsg-brl-content-container"
                style={contentContainerStyle}>
                
                {/* Name and Icon container */}
                <div className="hsg-brl-content-item"
                    style={firstViewStyle}>

                    <div className="hsg-brl-symbol-container">
                        {(Boolean(this.props.glyph) &&
                            <div className="hsg-brl-glyph-holder"
                                style={{color: this.options.glyphColor}}>

                                <Glyphicon glyph={this.props.glyph} />

                            </div>)

                        ||
                        
                        (Boolean(this.props.icon) &&
                            <div className="hsg-brl-icon-holder"><img className="hsg-brl-icon-image" src={this.props.icon} alt="report icon" /></div>)}
                    </div>

                    <div className="hsg-brl-name-container">
                        <p className="hsg-brl-name-text" style={{lineHeight: (this.options.height - 2) + 'px'}}>{this.props.name}</p>
                    </div>

                </div>

                {/* Report Status container */}
                <div className="hsg-brl-content-item">
                <div className="hsg-brl-status-wrapper">
                    
                    {(this.props.displayState === STATE_NORMAL &&
                        <div className="hsg-brl-status-icon-holder">
                            <span style={{padding: '0 2px'}}><Glyphicon glyph="star" /></span>
                            <span style={{padding: '0 2px'}}><Glyphicon glyph="star" /></span>
                            <span style={{padding: '0 2px'}}><Glyphicon glyph="star" /></span>
                        </div>)
                    
                    ||
                    
                    (this.props.displayState === STATE_NEED_ATTENTION &&
                        <div className="hsg-brl-status-icon-holder">
                            <Glyphicon glyph="alert" />
                        </div>)
                    }

                    <div className="hsg-brl-status-text-holder">
                        {
                            (this.props.displayState === STATE_NORMAL && 'NORMAL') ||
                            (this.props.displayState === STATE_NEED_ATTENTION && 'NEEDS ATTENTION') || 
                            (this.props.displayState === STATE_INCOMPLETED && this.props.incompleteMSG || 'INCOMPLETE')
                        }
                    </div>

                </div>
                </div>
            
            </div>

        </div>);
    }


    componentDidMount() {
        
    }


    componentWillReceiveProps(newProps) {
        this.options = Object.assign({}, options, newProps.options);

    }

}



ButtonReportLink.propTypes = {
    name: PropTypes.string.isRequired,
    displayState: PropTypes.number.isRequired,
    glyph: PropTypes.string,
    icon: PropTypes.string
};


// This will define the style of card

const options = {
    height: 72,
    backgroundColor: '#ffffff',
    highlightNormalColor: '#55BC6E',
    highlightAttentionColor: '#FFA200',
    highlightIncompletedColor: '#696969',
    highlightBorderWidth: 10,
    textColor: '#999999',
    glyphColor: '#999999'
};



ButtonReportLink.STATE_NORMAL = STATE_NORMAL;
ButtonReportLink.STATE_NEED_ATTENTION = STATE_NEED_ATTENTION;
ButtonReportLink.STATE_INCOMPLETED = STATE_INCOMPLETED;
